import {
  PlayerName,
  PlayerProfile,
  PlayerSubheader
} from '@library/components/player';
import { CloseIconButton } from '@library/components/buttons';
import type { RoleWithPermissions } from '@library/types/role';
import { StatusIndicator } from '@library/components/StatusIndicator';

export interface EditRoleHeaderProps {
  onClose: () => void;
  // onDelete: (roleId: string) => void;
  role: RoleWithPermissions;
}

export const EditRoleHeader = ({
  onClose,
  // onDelete,
  role
}: EditRoleHeaderProps) => {
  const { name, userCount } = role;
  const status = 'active';

  return (
    <PlayerProfile
      className="border-soFresh-140 flex h-16 flex-1 items-center gap-4 border-b border-solid p-3"
      name={name}
      subheader={`${userCount} users assigned`}
    >
      <div className="flex flex-col">
        <PlayerName className="font-heebo text-soClean-100 block text-sm font-medium tracking-tight" />
        <PlayerSubheader className="text-soClean-170 font-heebo block text-xs font-medium tracking-tight" />
      </div>
      <div className="text-soClean-110 flex flex-1 justify-end p-3 pr-1.5 text-xs capitalize">
        <StatusIndicator className="self-center" status={status} />
        <p className="pl-2">{status}</p>
      </div>
      {/* TEMP: Uncomment when _destroy attribute added to roles endpoint */}
      {/* <div className="flex">
        <UserKebabMenu
          deleteMessage="Delete role"
          menuActions={{ onDelete }}
          menuItemsClassName="!top-7 !bottom-auto !right-0"
          id={id}
        />
      </div> */}
      <CloseIconButton handleOnClick={onClose} />
    </PlayerProfile>
  );
};
